module.exports = __webpack_public_path__ + "img/Distribucion.7781c043.png";